export default function collectConsentedCookies({ categories, cookies }) {
  if ( !categories ) {
    return cookies.essential
  }

  const consentedCookies = Object.entries(cookies)
    .filter(([key]) => categories[key])
    .map(([key, value]) => value)

  return consentedCookies.flat()
}
